// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"9255fa694bb3f80a2406","293":"fbd09af6ffd7afbc6a2e","522":"e9fb79faa67234c9ad5b"}[chunkId] + ".js";
};